import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = ({ allowedGroups }) => {
    //OK-tracefabrics

    //const RequireAuth = ({ allowedPermissions }) => {
    const { auth } = useAuth();
    const location = useLocation();

    console.log("RequireAuth.js > RequireAuth > auth :", JSON.stringify(auth));

    if (!auth.isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!allowedGroups.includes(auth.group_name)) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    return <Outlet />;
}

export default RequireAuth


